import { motion } from "framer-motion";
import { BACKING, IMAGES } from "../../data";
import { Reveal, Kicker } from "./Reveal";

export default function Portfolio() {
  return (
    <section id="portfolio-section" data-testid="portfolio-section" className="py-24 lg:py-36 bg-sand2">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <div className="max-w-xl">
            <Reveal><Kicker>Our Approach</Kicker></Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 font-serif text-4xl sm:text-5xl text-ink tracking-tight leading-[1.08]">Who we back</h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <p className="text-stoneink max-w-sm">We are building our founding cohort now. These are the qualities we seek in every venture we choose to serve.</p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-3 gap-7">
          {BACKING.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.1}>
              <motion.article data-testid="portfolio-card-item" whileHover={{ y: -8 }} transition={{ type: "spring", stiffness: 260, damping: 22 }}
                className="group rounded-3xl overflow-hidden bg-cardw border border-borderln h-full flex flex-col">
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img src={IMAGES[p.img]} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <span className="absolute top-4 left-4 rounded-full bg-sand/90 backdrop-blur px-3 py-1 text-xs font-semibold text-bronze tracking-wide">{p.tag}</span>
                </div>
                <div className="p-7 flex flex-col flex-1">
                  <h3 className="font-serif text-2xl text-ink">{p.title}</h3>
                  <p className="mt-3 text-stoneink leading-relaxed">{p.quote}</p>
                </div>
              </motion.article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
